import validators from '../../utils/validators';

class HealthState {
  /**
   * @param data
   */
  constructor(data) {
    const properties = {
      id: (v) => validators.isNotEmptyString(v),
      user: (v) => validators.isNotEmptyString(v),
      health: (v) => validators.isNotEmptyString(v),
      value: (v) => validators.isNotEmptyString(v),
      createdAt: (v) => validators.isValidDate(v),
    };

    for (const property of Object.keys(properties)) {
      if (properties[property](data[property]) !== true) {
        throw new Error(`Invalid HealthState property ${property} "${data[property]}" in ${data.id}`);
      }

      if (property === 'createdAt') {
        if (typeof data[property] === 'string' && data[property].trim() !== '') {
          this[property] = new Date(data[property]);
        }
      } else {
        this[property] = data[property];
      }
    }
  }
}

export default HealthState;
